<template>
    <div v-observe-visibility="{ callback: isViewableNow, once: true }"
         :class="{'visible animated fadeInUp': shown, 'invisible': !shown }">
        <v-card
            max-width="800px"
            class="mx-auto"
            id="v-card-id"
    >
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title class="headline" style="white-space: pre-wrap;
                margin-bottom: 10px">{{blogArticle.title}}</v-list-item-title>
                <v-list-item-subtitle class="headline-info" style="white-space: pre-wrap;
                margin-bottom: 5px">by {{authorName}}, {{blogArticle.date}}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <ImageComponent :lazy="blogArticle.imgSrcLowRes" :url="blogArticle.imgSrc"></ImageComponent>
        <v-card-text class="text" style="text-align: left; color: black; white-space: pre-wrap;
        padding: 15px;" v-html="teaserText"></v-card-text>
        <v-card-actions style="align-items: center">
            <v-btn color="black" style="margin-left: auto; margin-right: auto; color: white" type="text" :to="{name: 'BlogDetailPage', params: { id: blogArticle.id, type: String }}"
            >
                Read
            </v-btn>
        </v-card-actions>
    </v-card>
    </div>
</template>

<script>
    import ImageComponent from "@/components/ImageComponent";
    import axios from 'axios';

    export default {
        name: "BlogArticleCard",
        components: { ImageComponent },
        props: {
            blogArticle: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                shown: false,
                authorName: null,
                teaserText: null
            }
        },
        mounted() {
            const url = 'https://heroku-adminservice.herokuapp.com/blogs/author';
            axios.get(url, {params: {blogId: this.blogArticle.id}}).then(response => {
                this.authorName = response.data.displayName;
            });
            this.teaserText = this.blogArticle.teaserText;
            //function to trim length
            const clientViewWidth = document.documentElement.clientWidth;
            console.log("client width: " + clientViewWidth);
            if (clientViewWidth < 1200) {
                this.trimTeaserTextLength();
            }
        },
        methods: {
            // eslint-disable-next-line no-unused-vars
            isViewableNow(isVisible, entry) {
                this.shown = isVisible;
            },

            trimTeaserTextLength() {
                let teaser = this.teaserText;
                let length = teaser.length;
                if(length>600)
                {
                    this.teaserText = teaser.substring(0,600)+'...';
                }

                console.log("trimmed teaser text " + this.teaserText);
            }
        },
    }
</script>

<style scoped>

    .headline {
        font-size: 35px; font-weight: bold;
    }

    .headline-info {
        font-size: 15px;
    }

    .text {
        font-size: 19px;
        line-height: 2rem;
    }

    @media only screen and (max-width: 500px) {
        .headline {
            font-size: 25px;
        }
    }

    @media screen and (max-width: 700px) {
        .text {
            font-size: 15px;
            line-height: 1.5rem;
        }
    }

    @media screen and (min-width: 1000px) {
        #v-card-id {
            border: 3px solid white;
        }
    }

</style>
